<ng-container *transloco="let t">
  @if (isOpen) {
    <core-dialog
      [dialogTitle]="dialogTitle"
      [confirmButtonText]="confirmButtonText"
      [closeButtonText]="closeButtonText"
      [saveIsDisabled]="!croppedImage"
      (saveDialogEvent)="onSave()"
      (closeDialogEvent)="onDialogClose()"
    >
      <div class="w-full max-w-2xl">
        <div class="mb-4 flex justify-center">
          <div class="w-full max-w-lg">
            <image-cropper
              [imageChangedEvent]="imageChangedEvent"
              [aspectRatio]="1"
              [roundCropper]="true"
              [alignImage]="'center'"
              [containWithinAspectRatio]="true"
              [format]="imageFormat"
              backgroundColor="#ffffff"
              (imageCropped)="onImageCropped($event)"
            ></image-cropper>
          </div>
        </div>

        @if (croppedImage) {
          <div class="mb-4">
            <div class="mb-2 text-sm font-semibold">
              {{ t('image-cropping-preview') }}:
            </div>
            <div class="flex justify-center">
              <div class="avatar">
                <div class="w-20 rounded-full">
                  <img
                    [src]="croppedImage"
                    alt="{{ t('image-cropping-preview-alt') }}"
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </core-dialog>
  }
</ng-container>
